import Input from '@/components/ui/Input';

export default function SectionOriginePropriete({ data, onChange }) {
  const val = (field) => field.split('.').reduce((obj, key) => obj?.[key], data) ?? '';
  const handleChange = (field) => (e) => onChange(field, e.target.value);
  const handleCheck = (field) => (e) => onChange(field, e.target.checked);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!data?.origine_propriete?.titre_communique}
            onChange={handleCheck('origine_propriete.titre_communique')}
            className="rounded border-slate-300"
          />
          Titre communiqué
        </label>
        <Input
          label="Acquéreur"
          name="origine_propriete.acquereur"
          value={val('origine_propriete.acquereur')}
          onChange={handleChange('origine_propriete.acquereur')}
        />
        <Input
          label="Notaire (nom)"
          name="origine_propriete.notaire_nom"
          value={val('origine_propriete.notaire_nom')}
          onChange={handleChange('origine_propriete.notaire_nom')}
        />
        <Input
          label="Notaire (ville)"
          name="origine_propriete.notaire_ville"
          value={val('origine_propriete.notaire_ville')}
          onChange={handleChange('origine_propriete.notaire_ville')}
        />
        <Input
          label="Date d'acquisition"
          name="origine_propriete.date_acquisition"
          type="date"
          value={val('origine_propriete.date_acquisition')}
          onChange={handleChange('origine_propriete.date_acquisition')}
        />
        <Input
          label="Prix d'acquisition (€)"
          name="origine_propriete.prix_acquisition_euros"
          type="number"
          value={val('origine_propriete.prix_acquisition_euros')}
          onChange={handleChange('origine_propriete.prix_acquisition_euros')}
        />
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!data?.origine_propriete?.compromis_en_cours}
            onChange={handleCheck('origine_propriete.compromis_en_cours')}
            className="rounded border-slate-300"
          />
          Compromis en cours
        </label>
        {data?.origine_propriete?.compromis_en_cours && (
          <>
            <Input
              label="Bénéficiaire du compromis"
              name="origine_propriete.compromis_beneficiaire"
              value={val('origine_propriete.compromis_beneficiaire')}
              onChange={handleChange('origine_propriete.compromis_beneficiaire')}
            />
            <Input
              label="Prix du compromis (€)"
              name="origine_propriete.compromis_prix_euros"
              type="number"
              value={val('origine_propriete.compromis_prix_euros')}
              onChange={handleChange('origine_propriete.compromis_prix_euros')}
            />
          </>
        )}
      </div>
    </div>
  );
}
